import { AppAction } from "../types";
import { SessionState } from "../types/SessionState";

/** All the session action types. */
export enum ActionKey {
  SET_SESSION_STATE = "SET_SESSION_STATE",
}

/** An action that sets the session state collectively. */
export interface SetSessionStateAction
  extends AppAction<ActionKey.SET_SESSION_STATE, { session: SessionState }> {}

/** All the session actions. */
export type SessionAction = SetSessionStateAction;

/** Sets the session state. */
export const createSetSessionStateAction = (
  session: SessionState
): SetSessionStateAction => ({
  type: ActionKey.SET_SESSION_STATE,
  payload: { session },
});
